<style lang="less" scoped>
    .layout-menu-left{
        // background: #464c5b;
        height: 100%;
        overflow: auto;
    }
    .layout-right{
        position: relative;
        // background: #eaedf1;
        padding: 0 0 0 15px;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .toggle-menu-icon-fold{
        transform: rotate(-90deg);
        animation:rotate 0.3s;
    }
    @keyframes rotate
    {
      from {transform: rotate(0deg)}
      to {transform: rotate(-90deg)}
    }
  .toggle-menu-icon-fold_two{
        transform: rotate(0deg);
        animation:rotate_two 0.3s;
    }
    @keyframes rotate_two
    {
      from {transform: rotate(-90deg)}
      to {transform: rotate(0deg)}
    }
    /deep/.ivu-menu-item {
        padding: 14px 12px;
    }
    .cash-income-contain {
        height: 90%;
    }
    .ivu-col{
      transition: width 0.2s ease-in-out;
    }
    .title-contain {
      display: flex;
      overflow: hidden;
      align-items: center;
      .title {
        margin-left: 10px;
        flex: 1;
        p {
          width: 100%;
          margin-bottom: 0px;
          font-size: 14px;
          min-width: 87px;
          font-weight: normal;
          overflow: hidden;
        }
      }
    }
</style>
<template>
  <div
    ref="contain"
    class="cash-income-contain"
    :style="{
      height: containHeight+'px'
    }"
  >
    <!-- <p
      class="error--text text-h6"
    >
      因近期数据迁移，二月份现金数据统计有误，开发正全力修复中...
    </p> -->
    <Row>
      <i-col
        :span="spanLeft"
        class="layout-menu-left"
      >
        <!--  'toggle-menu-icon-fold_two':spanLeft!==1 -->
        <Icon
          :size="20"
          type="md-menu"
          :class="{
            'toggle-menu-icon-fold':spanLeft===2,
            'toggle-menu-icon-fold_two':spanLeft!==2
          }"
          @click="toggleClick"
        />
        <Sider
          width="auto"
          :style="{background: '#fff'}"
        >
          <Menu
            :active-name="select_item"
            theme="light"
            width="auto"
            :open-names="[select_item]"
            @on-select="changeItem"
          >
            <MenuItem
              v-for="item in menu_list"
              :key="item.name"
              :name="item.name"
            >
              <div
                class="title-contain"
              >
                <Icon
                  :size="20"
                  :type="item.type"
                />
                <div
                  v-show="spanLeft!==2"
                  class="title"
                >
                  <p>
                    {{ item.title }}
                  </p>
                </div>
              </div>
            </MenuItem>
          </Menu>
        </Sider>
      </i-col>
      <i-col
        :span="spanRight"
        class="layout-right"
      >
        <div
          :style="{
            height: table_height+'px',
            overflow: 'auto',
          }"
        >
          <Tendency
            v-show="select_item==='selection-5'"
            ref="tendency"
            :table-height="table_height"
          />
          <OverView
            v-show="select_item==='selection-1'"
            ref="over_view"
            :table-height="table_height"
            :selected-item="select_item"
            :root-teams-hash="rootTeamsHash"
          />
          <HistoryData
            v-show="select_item==='selection-2'"
            ref="history_data"
            :root-teams-hash="rootTeamsHash"
          />
          <IndexDismantle
            v-show="select_item==='selection-3'"
            ref="index_dismantle"
            :get-history-data-decompose="getHistoryDataDecompose"
          />
          <DataExport
            v-show="select_item==='selection-4'"
            ref="data_export"
            :root-teams-hash="rootTeamsHash"
          />
        </div>
      </i-col>
    </Row>
  </div>
</template>
<script route="/dashBoard/cashIncome">
  import OverView from './components/Overview'
  // import Absolute from './components/Absolute'
  import HistoryData from './components/HistoryData'
  import IndexDismantle from './components/IndexDismantle'
  import DataExport from './components/DataExport'
  import Tendency from './components/Tendency'
  import {SELECTION_1, SELECTION_2, SELECTION_3, SELECTION_4, SELECTION_5 } from './constants'
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
  import { NAME_SPACE } from './constants'
  import { MENUS_LIST, ECHARTS_REF_HASH } from './fields'
  export default {
    /* router_info_start */
    router_info: '/dashBoard/cashIncome',
    /* router_info_end */
    components: {
      OverView,
      //  Absolute,
      HistoryData,
      IndexDismantle,
      DataExport,
      Tendency
    },
    data() {
      this.menu_list = MENUS_LIST
      return {
        select_item: SELECTION_1,
        spanLeft: 4,
        spanRight: 20,
      }
    },
    computed: {
      ...mapState(NAME_SPACE, {
        loading:'loading',
        changeTag: 'changeTag',
        historyData: 'historyData',
        overviewData: 'overviewData',
        historyDataDecompose: 'historyDataDecompose',
        dataExportData: 'dataExportData',
        echartsResize:'echartsResize',
      }),
      ...mapGetters({
        teams_hash: 'async/product_teams_hash',
      }),
      rootTeamsHash() {
        return {
          0:{
            name:'其他'
          },
          ...this.teams_hash
        }
      },
      table_height() { // 整个内容区高度
        const window_height = this.$store.state.window_height;
        return this.is_full_screen ? window_height - 11 : window_height - 155;
      },
      containHeight() {
        const window_height = this.$store.state.window_height;
        return this.is_full_screen ? window_height : window_height - 166;
      },
      fullcontainHeight() {
        const window_height = this.$store.state.window_height;
        return window_height;
      },
      is_full_screen() {
        return this.$store.state.full_screen
      }
    },
    mounted() {
      this.getCanSelect()
      this.changeItem (SELECTION_1)
      window.addEventListener("resize", this.windowResize);
      eventHub.$on('menu-resize', this.windowResize);
    },
    destroyed() {
      this.initState()
      window.removeEventListener("resize", this.windowResize);
      eventHub.$off('menu-resize', this.windowResize);
    },
    methods: {
      toggleClick() {
        if (this.spanLeft === 4) {
          this.spanLeft = 2;
          this.spanRight = 22;
        } else {
          this.spanLeft = 4;
          this.spanRight = 20;
        }
        setTimeout(() => {
          this.resizeCall('all')
        }, 300)
      },
      changeItem(data) {
        this.select_item = data
        let call = null
        this.$nextTick(() => this.resizeSelectedItem(data))
        switch (data) {
        case SELECTION_1:
          if (this.overviewData || this.loading.getOverviewDataLoading) {
            return
          }
          call = this.$refs['over_view'].getData
          break
        case SELECTION_2:
          if (this.historyData || this.loading.getHistoryDataLoading) {
            return
          }
          call = this.$refs['history_data'].getData
          break;
        case SELECTION_3:
          if (this.historyDataDecompose || this.loading.getHistoryDataDecomposeLoading) {
            return
          }
          call = this.$refs['index_dismantle'].getData
          break;
        case SELECTION_4:
          if (this.dataExportData || this.loading.getDataExportLoading) {
            return
          }
          call = this.$refs['data_export'].getData
          break
        case SELECTION_5:
          call = this.$refs['tendency'].getData
          break
        default:
          break;
        }
        this.proxyGetData(call)
      },
      resizeSelectedItem(selected) {
        if (ECHARTS_REF_HASH[selected]) {
          this.$refs[ECHARTS_REF_HASH[selected]].resizeEchart()
        }
      },
      proxyGetData(call) { // 确保获取数据前已获取团队信息
        if (Object.keys(this.rootTeamsHash).length === 1) {
          setTimeout(() => {
            this.proxyGetData(call)
          }, 100)
          return
        }
        if (call) {
          call()
        }
      },
      ...mapMutations(NAME_SPACE,
                      [
                        'addEchartsResize',
                        'resizeCall',
                        'initState'
                      ]),
      ...mapActions(NAME_SPACE, [
        'getHistoryData',
        'getHistoryDataDecompose',
        'getCanSelect'
      ]),
      windowResize() {
        console.log('我们的测试测试')
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.timer = null
          this.$nextTick(() => this.resizeSelectedItem(this.select_item))
        }, 500)
      },
    },
  }
</script>
